import { IconProps } from './types';

interface Props extends IconProps {
  fill: '#000' | '#fff' | 'inherit';
}

export const MymeTimeBasedIcon = ({ fill, ...props }: Props) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.881 19.881'>
    <path
      // eslint-disable-next-line max-len
      d='M13.306,3.375a9.941,9.941,0,1,0,9.95,9.941A9.937,9.937,0,0,0,13.306,3.375Zm.01,17.893a7.952,7.952,0,1,1,7.952-7.952A7.952,7.952,0,0,1,13.316,21.268Z'
      transform='translate(-3.375 -3.375)'
      fill={fill || 'rgba(0,0,0,0.9)'}
      {...props}
    />
    <path
      d='M18.029,10.688H16.538v5.964l5.219,3.13.746-1.223-4.473-2.652Z'
      transform='translate(-7.591 -5.717)'
      fill={fill || 'rgba(0,0,0,0.9)'}
      {...props}
    />
  </svg>
);
